import { useEffect, useState } from 'react';

// The official (uploaded) PDF for a song is only known to the song list, so
// look it up there by file name. The list is fetched once per page load.
const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
let listPromise = null;

function fetchSongList() {
  if (!listPromise) {
    listPromise = fetch(`${API_BASE}/api/musicxml?operation=list`)
      .then(response => response.json())
      .then(data => data.files || [])
      .catch(() => {
        listPromise = null; // allow a retry next time
        return [];
      });
  }
  return listPromise;
}

export function useOfficialPdfUrl(fileName) {
  const [pdfUrl, setPdfUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setPdfUrl(null);
    if (!fileName) return undefined;
    fetchSongList().then(files => {
      if (cancelled) return;
      const match = files.find(file => file.filename === fileName);
      setPdfUrl(match?.pdfUrl || null);
    });
    return () => { cancelled = true; };
  }, [fileName]);
  return pdfUrl;
}
